import { render, staticRenderFns } from "./Alternatives.vue?vue&type=template&id=b5b0c614&"
import script from "./Alternatives.vue?vue&type=script&lang=js&"
export * from "./Alternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports